module.exports = __webpack_public_path__ + "img/tripe_win_ko.67ffdd40.svg";